import styled from 'styled-components';
import primitives from '@veneer/primitives';
import { Button } from '@veneer/core';
import divHTMLRender from '../../../shared/divHTMLRender';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${primitives.layout.size3}px;
`;

export const Description = styled(divHTMLRender)`
  margin: 0;
  color: ${primitives.color.gray11};

  a {
    color: ${({ theme }) => theme.color.primary.base.default};
    text-decoration: underline;
    align-items: center;

    &:focus {
      outline: none;
      box-shadow: none;
    }

    &:focus-visible {
      outline: ${({ $isTabNavigation, theme }) => ($isTabNavigation
    ? `2px solid ${theme.color.primary.base.default}`
    : 'none')};
      outline-offset: ${({ $isTabNavigation }) => ($isTabNavigation ? '2px' : '0')};
    }

    &:hover {
      color: ${({ theme }) => theme.color.primary.base.hover};
      svg {
        color: ${({ theme }) => theme.color.primary.base.hover};
      }
    }

    &:active {
      color: ${({ theme }) => theme.color.primary.base.active};
      svg {
        color: ${({ theme }) => theme.color.primary.base.active};
      }
    }
  }

  svg {
    vertical-align: text-bottom;
    margin-left: ${primitives.layout.size1}px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${primitives.layout.size3}px;
  padding-top: ${primitives.layout.size5}px;
`;

export const ModalButton = styled(Button)`
  border-radius: ${primitives.layout.cornerRadius2}px !important;
`;
